import { QuestionData } from "../components/quiz/typesAndEnums";

export type ResultI = { score: number; maxScore: number, elapsedSeconds: number } & {
  [key: string]: {
    correct: boolean;
    answer: string;
  };
};

const useAssessmentController = () => {
  const getResult = async ({
    elapsedSeconds,
    userAnswers,
    questions,
  }: {
    elapsedSeconds: number;
    userAnswers: {
      [key: number]: string;
    };
    questions: QuestionData[];
  }) => {
    let score = 0;
    let maxScore = 0;
    let gradedQuestions: {
      [key: string]: {
        correct: boolean;
        answer: string;
        order: number;
      };
    } = {};
    questions.forEach((q, idx) => {
      maxScore += q.weight;
      const isCorrect = q.correct_answer === userAnswers[q.question_id];
      if (isCorrect) score += q.weight;
      gradedQuestions[q.question_id] = {
        answer: userAnswers[q.question_id],
        correct: isCorrect,
        order: idx,
      };
    });

    return {
      elapsedSeconds,
      score,
      maxScore,
      ...gradedQuestions,
    } as ResultI;
  };

  return { getResult };
};

export default useAssessmentController;
